import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router';
import TopMsgSlider from './TopMsgSlider';

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimated, setIsAnimated] = useState(false);

  const handleCrossClick = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimated(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div>

        {/* {isVisible && (
          <TopMsgSlider />
        )} */}


        {/* <img className="logonav" src="images/logo.png" alt="" /> */}
        
        {/* <img className='lineimg1' src="/images/line.png" alt="" /> */}
          <hr className="hrnavbar nomargin" />
          
        <div className='otherdeco2'>
          <img className='decoimg31' src="/images/f5.png" alt="" />
          <img className='decoimg41' src="/images/f1.png" alt="" />
        </div>

        <img className="logonav" src="images/aa.png" alt="" />
        <img className="logonavsince" src="images/since.png" alt="" />
        {/* <hr className="hrnavbar" /> */}
        {/* <div className='lessspace linesdiv'> */}

          {/* <img className='lineimg2' src="/images/line.png" alt="" /> */}

          <hr className="hrnavbar" />
          {/* <hr /> */}
        {/* </div> */}
        <ul className="navul">
          {/* <li> */}
            {/* <NavLink className="navlink" to="/aboutus">Home</NavLink> */}
            <NavLink className="navlink" to="/aboutus">
              <img className='navbarimgs' src="/images/n1.png" alt="not found" />
            </NavLink>
          {/* </li> */}
          {/* <li> */}
            {/* <NavLink className="navlink" to="/menu">Menu</NavLink> */}
            <NavLink className="navlink" to="/menu">
              <img className='extraspace navbarimgs' src="/images/n2.png" alt="not found" />
            </NavLink>
          {/* </li> */}
          {/* <li> */}
            {/* <NavLink className="navlink" to="/contact">Contact</NavLink> */}
            <NavLink className="navlink" to="/contact">
              <img className='navbarimgs' src="/images/n3.png" alt="not found" />
            </NavLink>
          {/* </li> */}
          {/* <li> */}
            {/* <NavLink className="navlink" to="/faqs">FAQ's</NavLink> */}
            <NavLink className="navlink" to="/faqs">
              <img className='navbarimgs' src="/images/n4.png" alt="not found" />
            </NavLink>
          {/* </li> */}
        </ul>

      </div>
    </>
  );
};

export default Navbar;
